import { render, staticRenderFns } from "./VerifyLink.vue?vue&type=template&id=710a70f7&"
import script from "./VerifyLink.vue?vue&type=script&lang=js&"
export * from "./VerifyLink.vue?vue&type=script&lang=js&"
import style0 from "./VerifyLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports